var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoinStackIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon coin-stack-icon",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0c5.476 0 9.924 2.25 9.999 5.04H20v8.917C20 17.294 15.523 20 10 20 4.58 20 .166 17.394.005 14.142L0 13.957V5.039h.002l.003-.087C.169 2.202 4.58 0 10 0zm0 15.111c-3.589 0-6.736-1.142-8.5-2.858v1.704c0 2.26 3.546 4.45 8.201 4.54L10 18.5c4.702 0 8.345-2.143 8.495-4.399l.005-.144.001-1.705c-1.764 1.716-4.912 2.86-8.501 2.86zm0-4.889c-3.589 0-6.736-.966-8.5-2.418v1.264c0 2.26 3.546 4.45 8.201 4.54l.299.003c4.702 0 8.345-2.143 8.495-4.399l.005-.144.001-1.264C16.738 9.256 13.59 10.222 10 10.222zM10 1.5c-4.802 0-8.5 1.89-8.5 3.611 0 1.721 3.698 3.611 8.5 3.611s8.5-1.89 8.5-3.61C18.5 3.39 14.802 1.5 10 1.5z"
  })));
}

export default SvgCoinStackIconSv;